[
  {
    "brandName": "ACTRAPID HM",
    "genericName": "Human insulin / regular insulin",
    "strength": "100 IU/ml",
    "form": "Injection",
    "category": "Diabetes / Insulin",
    "commonUse": "Short-acting insulin for blood glucose control",
    "riskNotes": "Dose and timing must match meals and glucose monitoring; hypoglycemia risk.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "DOXICAP",
    "genericName": "Doxycycline",
    "strength": "100 mg",
    "form": "Capsule",
    "category": "Antibiotic",
    "commonUse": "Bacterial infections",
    "riskNotes": "Avoid taking with milk, antacids, iron, or zinc at the same time.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "NAPA RAPID",
    "genericName": "Paracetamol",
    "strength": "500 mg",
    "form": "Tablet",
    "category": "Pain / Fever",
    "commonUse": "Fever, headache, mild pain",
    "riskNotes": "Avoid duplicate paracetamol products and high total daily dose.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "NAPA",
    "genericName": "Paracetamol",
    "strength": "500 mg",
    "form": "Tablet",
    "category": "Pain / Fever",
    "commonUse": "Fever, headache, mild pain",
    "riskNotes": "Avoid duplicate paracetamol products and high total daily dose.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "RIVOTRIL",
    "genericName": "Clonazepam",
    "strength": "0.5 mg / 2 mg",
    "form": "Tablet",
    "category": "Neurology / Sedative",
    "commonUse": "Seizure disorders, panic disorder, sleep-related symptoms when prescribed",
    "riskNotes": "Sedation and dependence risk; avoid alcohol and other sedatives unless prescribed.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "MONOCAST",
    "genericName": "Montelukast",
    "strength": "10 mg",
    "form": "Tablet",
    "category": "Respiratory / Allergy",
    "commonUse": "Asthma and allergic rhinitis support",
    "riskNotes": "Report mood or sleep changes to a clinician.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "DOXIVA",
    "genericName": "Doxofylline",
    "strength": "400 mg",
    "form": "Tablet",
    "category": "Respiratory",
    "commonUse": "Asthma or COPD symptom control when prescribed",
    "riskNotes": "May cause palpitations, nausea, or sleep disturbance in some patients.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "PREGABA",
    "genericName": "Pregabalin",
    "strength": "50 mg / 75 mg",
    "form": "Capsule",
    "category": "Neuropathic pain",
    "commonUse": "Neuropathic pain and nerve-related symptoms",
    "riskNotes": "May cause dizziness or sleepiness; caution with sedatives.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "ANGILOCK",
    "genericName": "Losartan potassium",
    "strength": "50 mg",
    "form": "Tablet",
    "category": "Blood pressure",
    "commonUse": "High blood pressure",
    "riskNotes": "Monitor blood pressure; caution with potassium supplements unless prescribed.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "SELO",
    "genericName": "Metoprolol",
    "strength": "50 mg",
    "form": "Tablet",
    "category": "Blood pressure / Heart",
    "commonUse": "Blood pressure and heart rate control",
    "riskNotes": "Do not stop suddenly without clinician advice.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "SECLON",
    "genericName": "Clonazepam",
    "strength": "0.5 mg / 2 mg",
    "form": "Tablet",
    "category": "Neurology / Sedative",
    "commonUse": "Seizure disorders and anxiety-related symptoms when prescribed",
    "riskNotes": "Sedation risk; avoid alcohol and unprescribed sedatives.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "SECLO",
    "genericName": "Omeprazole",
    "strength": "20 mg",
    "form": "Capsule",
    "category": "Gastric / Acid reducer",
    "commonUse": "Acidity, reflux, ulcer prevention when prescribed",
    "riskNotes": "Take timing as prescribed, often before meals.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "SERGEL",
    "genericName": "Esomeprazole",
    "strength": "20 mg / 40 mg",
    "form": "Capsule",
    "category": "Gastric / Acid reducer",
    "commonUse": "Acidity, reflux, ulcer prevention when prescribed",
    "riskNotes": "Take timing as prescribed, often before meals.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "MAXPRO",
    "genericName": "Esomeprazole",
    "strength": "20 mg / 40 mg",
    "form": "Capsule",
    "category": "Gastric / Acid reducer",
    "commonUse": "Acidity, reflux, ulcer prevention when prescribed",
    "riskNotes": "Take timing as prescribed, often before meals.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "FINIX",
    "genericName": "Rabeprazole",
    "strength": "20 mg",
    "form": "Tablet",
    "category": "Gastric / Acid reducer",
    "commonUse": "Acidity, reflux, ulcer prevention when prescribed",
    "riskNotes": "Take timing as prescribed, often before meals.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "FEXO",
    "genericName": "Fexofenadine",
    "strength": "120 mg / 180 mg",
    "form": "Tablet",
    "category": "Antihistamine",
    "commonUse": "Allergy symptoms",
    "riskNotes": "Separate from some antacids and fruit juice if instructed.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "CETRIZIN",
    "genericName": "Cetirizine",
    "strength": "10 mg",
    "form": "Tablet",
    "category": "Antihistamine",
    "commonUse": "Allergy symptoms",
    "riskNotes": "May cause sleepiness in some patients.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "MONTENE",
    "genericName": "Montelukast",
    "strength": "10 mg",
    "form": "Tablet",
    "category": "Respiratory / Allergy",
    "commonUse": "Asthma and allergic rhinitis support",
    "riskNotes": "Report mood or sleep changes to a clinician.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "MONTELAIR",
    "genericName": "Montelukast",
    "strength": "10 mg",
    "form": "Tablet",
    "category": "Respiratory / Allergy",
    "commonUse": "Asthma and allergic rhinitis support",
    "riskNotes": "Report mood or sleep changes to a clinician.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "AMLOCARD",
    "genericName": "Amlodipine",
    "strength": "5 mg",
    "form": "Tablet",
    "category": "Blood pressure",
    "commonUse": "High blood pressure",
    "riskNotes": "May cause ankle swelling or dizziness.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "AMODIS",
    "genericName": "Metronidazole",
    "strength": "400 mg",
    "form": "Tablet",
    "category": "Antibiotic / Antiprotozoal",
    "commonUse": "Certain stomach, dental, or protozoal infections when prescribed",
    "riskNotes": "Avoid alcohol during treatment and shortly after unless clinician advises otherwise.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "COMET",
    "genericName": "Metformin",
    "strength": "500 mg",
    "form": "Tablet",
    "category": "Diabetes",
    "commonUse": "Blood glucose control",
    "riskNotes": "Take with food if prescribed; report severe stomach upset or unusual weakness.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "GLUCOMIN",
    "genericName": "Metformin",
    "strength": "500 mg / 850 mg",
    "form": "Tablet",
    "category": "Diabetes",
    "commonUse": "Blood glucose control",
    "riskNotes": "Take with food if prescribed; report severe stomach upset or unusual weakness.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "AMARYL",
    "genericName": "Glimepiride",
    "strength": "1 mg / 2 mg",
    "form": "Tablet",
    "category": "Diabetes",
    "commonUse": "Blood glucose control",
    "riskNotes": "Hypoglycemia risk if meals are missed.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "ATORVA",
    "genericName": "Atorvastatin",
    "strength": "10 mg / 20 mg",
    "form": "Tablet",
    "category": "Cholesterol",
    "commonUse": "Cholesterol reduction",
    "riskNotes": "Report unexplained muscle pain or weakness.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "BRUFEN",
    "genericName": "Ibuprofen",
    "strength": "400 mg",
    "form": "Tablet",
    "category": "Pain / NSAID",
    "commonUse": "Pain and inflammation when prescribed",
    "riskNotes": "Caution with stomach ulcer, kidney disease, blood thinners, or high blood pressure.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "VOLTAREN",
    "genericName": "Diclofenac",
    "strength": "50 mg",
    "form": "Tablet",
    "category": "Pain / NSAID",
    "commonUse": "Pain and inflammation when prescribed",
    "riskNotes": "Caution with stomach ulcer, kidney disease, blood thinners, or high blood pressure.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "UROMAX D",
    "genericName": "Tamsulosin + Dutasteride",
    "strength": "0.4 mg + 0.5 mg",
    "form": "Capsule",
    "category": "Urology / Prostate",
    "commonUse": "Urinary symptoms related to prostate enlargement when prescribed",
    "riskNotes": "May cause dizziness; confirm use and duration with the prescriber.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "XIOMOX",
    "genericName": "Moxifloxacin",
    "strength": "400 mg",
    "form": "Tablet",
    "category": "Antibiotic",
    "commonUse": "Bacterial infection treatment when prescribed",
    "riskNotes": "Complete only as prescribed; confirm if heart rhythm problems or tendon pain occur.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "EFODIO",
    "genericName": "Domperidone maleate",
    "strength": "10 mg",
    "form": "Tablet",
    "category": "Gastrointestinal / Prokinetic",
    "commonUse": "Nausea, vomiting, bloating, or gastric motility support when prescribed",
    "riskNotes": "Confirm use with a doctor if there is heart rhythm disease, fainting, or other QT-risk medicine.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "DEXILEND",
    "genericName": "Dexlansoprazole",
    "strength": "30 mg",
    "form": "Capsule",
    "category": "Gastric / Acid reducer",
    "commonUse": "Acidity, reflux, or stomach protection when prescribed",
    "riskNotes": "Take timing as prescribed and confirm long duration with the doctor.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "WINDEL PLUS",
    "genericName": "Ipratropium bromide + Salbutamol",
    "strength": "Nebulizer respule",
    "form": "Nebulization",
    "category": "Respiratory / Bronchodilator",
    "commonUse": "Breathing support by nebulization when prescribed",
    "riskNotes": "Use only by the prescribed nebulization schedule; seek care for worsening breathing.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "BUDICORT",
    "genericName": "Budesonide",
    "strength": "Nebulizer respule",
    "form": "Nebulization",
    "category": "Respiratory / Inhaled corticosteroid",
    "commonUse": "Airway inflammation support by nebulization when prescribed",
    "riskNotes": "Rinse mouth after use when advised; confirm nebulizer dose with the medicine pack.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "GLYMPON",
    "genericName": "Empagliflozin + Linagliptin",
    "strength": "25 mg + 5 mg",
    "form": "Tablet",
    "category": "Diabetes",
    "commonUse": "Blood sugar control when prescribed",
    "riskNotes": "Hypoglycemia risk depends on other diabetes medicines and meals; confirm exact strength from strip.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "GLYMPA",
    "genericName": "Empagliflozin + Linagliptin",
    "strength": "25 mg + 5 mg",
    "form": "Tablet",
    "category": "Diabetes",
    "commonUse": "Blood sugar control when prescribed",
    "riskNotes": "Hypoglycemia risk depends on other diabetes medicines and meals; confirm exact brand and strength from strip.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "NEURO B",
    "genericName": "Vitamin B1 + Vitamin B6 + Vitamin B12",
    "strength": "Combination",
    "form": "Tablet",
    "category": "Vitamin / Nerve support",
    "commonUse": "Vitamin B support for nerve-related symptoms when prescribed",
    "riskNotes": "Confirm dose and duration if taking other vitamin products.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "EGGCAL DX",
    "genericName": "Calcium + Vitamin D3",
    "strength": "Combination",
    "form": "Tablet",
    "category": "Calcium / Vitamin D",
    "commonUse": "Calcium and vitamin D support when prescribed",
    "riskNotes": "Separate from some antibiotics or thyroid medicine if advised by a professional.",
    "confidenceSource": "Curated Bangladesh brand database"
  },
  {
    "brandName": "AQUAFRESH E/D",
    "genericName": "Carboxymethylcellulose sodium",
    "strength": "Eye drop",
    "form": "Eye drop",
    "category": "Ophthalmic lubricant",
    "commonUse": "Dry, irritated, or itchy eyes when prescribed",
    "riskNotes": "Use in the eye only. Avoid touching the dropper tip and confirm duration if symptoms persist.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "AQUAFRESH",
    "genericName": "Carboxymethylcellulose sodium",
    "strength": "Eye drop",
    "form": "Eye drop",
    "category": "Ophthalmic lubricant",
    "commonUse": "Dry, irritated, or itchy eyes when prescribed",
    "riskNotes": "Use in the eye only. Avoid touching the dropper tip and confirm duration if symptoms persist.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "FENADIN",
    "genericName": "Fexofenadine hydrochloride",
    "strength": "120 mg",
    "form": "Tablet",
    "category": "Antihistamine",
    "commonUse": "Allergy symptoms",
    "riskNotes": "May be less effective with some antacids or fruit juice; follow pharmacist advice.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "AFRIN NASAL DROP",
    "genericName": "Oxymetazoline hydrochloride",
    "strength": "0.05%",
    "form": "Nasal drop",
    "category": "Nasal decongestant",
    "commonUse": "Blocked nose or nasal congestion when prescribed",
    "riskNotes": "Do not use longer than prescribed; overuse can worsen congestion.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "AFRIN",
    "genericName": "Oxymetazoline hydrochloride",
    "strength": "0.05%",
    "form": "Nasal drop",
    "category": "Nasal decongestant",
    "commonUse": "Blocked nose or nasal congestion when prescribed",
    "riskNotes": "Do not use longer than prescribed; overuse can worsen congestion.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "OTHIN",
    "genericName": "Bilastine",
    "strength": "20 mg",
    "form": "Tablet",
    "category": "Antihistamine",
    "commonUse": "Allergy symptoms when prescribed",
    "riskNotes": "Confirm timing with food as some antihistamines work best away from meals.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "FUROTIL PLUS",
    "genericName": "Cefuroxime + Clavulanic acid",
    "strength": "250 mg + 62.5 mg / 500 mg + 125 mg",
    "form": "Tablet",
    "category": "Antibiotic",
    "commonUse": "Bacterial infection treatment when prescribed",
    "riskNotes": "Complete only as prescribed and confirm allergy history before taking antibiotics.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "NORMAL SALINE",
    "genericName": "Sodium chloride 0.9%",
    "strength": "0.9%",
    "form": "Nasal/irrigation solution",
    "category": "Saline support",
    "commonUse": "Nasal wash, cleaning, or dilution support when prescribed",
    "riskNotes": "Use only by the route and amount written in the prescription.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "AERON",
    "genericName": "Montelukast",
    "strength": "10 mg",
    "form": "Tablet",
    "category": "Respiratory / Allergy",
    "commonUse": "Asthma or allergic rhinitis support when prescribed",
    "riskNotes": "Report mood or sleep changes to a clinician.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "OXOFYLLINE",
    "genericName": "Doxofylline",
    "strength": "400 mg",
    "form": "Tablet",
    "category": "Respiratory",
    "commonUse": "Breathing support in asthma/COPD-type symptoms when prescribed",
    "riskNotes": "May cause palpitations, nausea, or sleep disturbance in some patients.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "FLAMEX",
    "genericName": "Ibuprofen",
    "strength": "400 mg",
    "form": "Tablet",
    "category": "Pain / NSAID",
    "commonUse": "Pain, fever, or inflammation when prescribed",
    "riskNotes": "Caution with stomach ulcer, kidney disease, blood thinners, or high blood pressure.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "ORS",
    "genericName": "Oral rehydration salts",
    "strength": "Sachet / solution",
    "form": "Oral solution",
    "category": "Rehydration",
    "commonUse": "Fluid and electrolyte replacement when prescribed",
    "riskNotes": "Prepare with clean water exactly as directed on the packet.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "PERMETHRIN CREAM",
    "genericName": "Permethrin",
    "strength": "5%",
    "form": "Cream",
    "category": "Dermatology / Anti-scabies",
    "commonUse": "Scabies treatment when prescribed",
    "riskNotes": "Apply exactly as instructed and avoid eyes/mouth; household hygiene instructions matter.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "PERMETHRIN",
    "genericName": "Permethrin",
    "strength": "5%",
    "form": "Cream",
    "category": "Dermatology / Anti-scabies",
    "commonUse": "Scabies treatment when prescribed",
    "riskNotes": "Apply exactly as instructed and avoid eyes/mouth; household hygiene instructions matter.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "CEFUROXIME SYRUP",
    "genericName": "Cefuroxime",
    "strength": "Syrup",
    "form": "Syrup",
    "category": "Antibiotic",
    "commonUse": "Bacterial infection treatment when prescribed",
    "riskNotes": "Complete only as prescribed and confirm allergy history before taking antibiotics.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "CEFUROXIME",
    "genericName": "Cefuroxime",
    "strength": "Syrup / tablet",
    "form": "Syrup",
    "category": "Antibiotic",
    "commonUse": "Bacterial infection treatment when prescribed",
    "riskNotes": "Complete only as prescribed and confirm allergy history before taking antibiotics.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "CETIRIZINE SYRUP",
    "genericName": "Cetirizine",
    "strength": "Syrup",
    "form": "Syrup",
    "category": "Antihistamine",
    "commonUse": "Allergy or itching symptoms when prescribed",
    "riskNotes": "May cause sleepiness in some patients.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "CETIRIZINE",
    "genericName": "Cetirizine",
    "strength": "10 mg / syrup",
    "form": "Tablet / syrup",
    "category": "Antihistamine",
    "commonUse": "Allergy or itching symptoms when prescribed",
    "riskNotes": "May cause sleepiness in some patients.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "NAPROXEN + ESOMEPRAZOLE",
    "genericName": "Naproxen + Esomeprazole",
    "strength": "375 mg + 20 mg",
    "form": "Tablet",
    "category": "Pain / NSAID + gastric protection",
    "commonUse": "Pain and inflammation with stomach protection when prescribed",
    "riskNotes": "Caution with ulcer, kidney disease, blood thinners, heart disease, or high blood pressure.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "VITAMIN B1 B6 B12",
    "genericName": "Vitamin B1 + Vitamin B6 + Vitamin B12",
    "strength": "Combination",
    "form": "Tablet",
    "category": "Vitamin / Nerve support",
    "commonUse": "Vitamin B support for nerve-related symptoms when prescribed",
    "riskNotes": "Confirm dose and duration if taking other vitamin products.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "BACLOFEN",
    "genericName": "Baclofen",
    "strength": "10 mg",
    "form": "Tablet",
    "category": "Muscle relaxant",
    "commonUse": "Muscle spasm or pain support when prescribed",
    "riskNotes": "May cause sleepiness or dizziness; avoid alcohol and do not stop suddenly without advice.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "CLONAZEPAM",
    "genericName": "Clonazepam",
    "strength": "0.5 mg",
    "form": "Tablet",
    "category": "Neurology / Sedative",
    "commonUse": "Sleep, anxiety, seizure, or nerve-related symptoms when prescribed",
    "riskNotes": "Sedation and dependence risk; avoid alcohol and other sedatives unless prescribed.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "PREGABALIN",
    "genericName": "Pregabalin",
    "strength": "25 mg / 50 mg / 75 mg",
    "form": "Capsule",
    "category": "Neuropathic pain",
    "commonUse": "Neuropathic pain and nerve-related symptoms",
    "riskNotes": "May cause dizziness or sleepiness; caution with sedatives.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "MONTELUKAST",
    "genericName": "Montelukast",
    "strength": "10 mg",
    "form": "Tablet",
    "category": "Respiratory / Allergy",
    "commonUse": "Asthma and allergic rhinitis support",
    "riskNotes": "Report mood or sleep changes to a clinician.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "PANTOPRAZOLE",
    "genericName": "Pantoprazole",
    "strength": "20 mg / 40 mg",
    "form": "Tablet",
    "category": "Gastric / Acid reducer",
    "commonUse": "Acidity, reflux, or stomach protection when prescribed",
    "riskNotes": "Often taken before meals when prescribed; confirm long duration with the doctor.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "ACE XR",
    "genericName": "Paracetamol",
    "strength": "665 mg",
    "form": "Extended-release tablet",
    "category": "Pain / Fever",
    "commonUse": "Fever, headache, or mild pain when prescribed",
    "riskNotes": "Avoid duplicate paracetamol products and high total daily dose.",
    "confidenceSource": "Curated prescription showcase database"
  },
  {
    "brandName": "CALCIUM CARBONATE + VITAMIN D",
    "genericName": "Calcium carbonate + Vitamin D",
    "strength": "500 mg + Vitamin D",
    "form": "Tablet",
    "category": "Calcium / Vitamin D",
    "commonUse": "Calcium and vitamin D support when prescribed",
    "riskNotes": "Separate from some antibiotics or thyroid medicine if advised by a professional.",
    "confidenceSource": "Curated prescription showcase database"
  }
]
